import { useState } from "react";
import axios from "axios";
import { Mail, Lock, User, Eye, EyeOff, Loader } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

function fmt(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Register() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  if (!token) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg)" }}>
      <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 12, padding: 36, textAlign: "center", color: "var(--text-muted)", maxWidth: 360 }}>
        <p>Invalid or missing invite link.</p>
      </div>
    </div>
  );

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    setError(""); setLoading(true);
    try {
      await axios.post(`${API}/api/auth/register`, { token, name, password }, { withCredentials: true });
      setDone(true);
      setTimeout(() => window.location.href = "/", 1500);
    } catch (err) {
      setError(fmt(err?.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  if (done) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg)" }}>
      <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 12, padding: 36, textAlign: "center", maxWidth: 360 }}>
        <div style={{ color: "#22c55e", fontSize: 16, fontWeight: 600 }}>Account created! Redirecting…</div>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg)", fontFamily: "var(--font)" }}>
      <div style={{ width: 380, background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 12, padding: "40px 36px", boxShadow: "0 8px 32px rgba(0,0,0,.4)" }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: "var(--text-primary)" }}>Create your account</div>
          <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 4 }}>You've been invited to the Email Delivery Engine</div>
        </div>
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div style={{ position: "relative" }}>
            <User size={15} style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-muted)", pointerEvents: "none" }} />
            <input type="text" placeholder="Your name" value={name} onChange={e => setName(e.target.value)}
              style={{ width: "100%", padding: "10px 12px 10px 36px", background: "var(--bg)", border: "1px solid var(--border)", borderRadius: 7, color: "var(--text-primary)", fontSize: 14, outline: "none", boxSizing: "border-box" }} />
          </div>
          <div style={{ position: "relative" }}>
            <Lock size={15} style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-muted)", pointerEvents: "none" }} />
            <input type={show ? "text" : "password"} placeholder="Create password (min 8 chars)" value={password} onChange={e => setPassword(e.target.value)} required
              style={{ width: "100%", padding: "10px 36px 10px 36px", background: "var(--bg)", border: "1px solid var(--border)", borderRadius: 7, color: "var(--text-primary)", fontSize: 14, outline: "none", boxSizing: "border-box" }} />
            <button type="button" onClick={() => setShow(s => !s)} style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)", padding: 4 }}>
              {show ? <EyeOff size={15} /> : <Eye size={15} />}
            </button>
          </div>
          {error && <div style={{ background: "rgba(239,68,68,.1)", border: "1px solid rgba(239,68,68,.3)", borderRadius: 6, padding: "8px 12px", fontSize: 13, color: "#ef4444" }}>{error}</div>}
          <button type="submit" disabled={loading} style={{ marginTop: 4, padding: 11, borderRadius: 7, border: "none", background: loading ? "var(--border)" : "var(--accent)", color: "#fff", fontWeight: 600, fontSize: 14, cursor: loading ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
            {loading ? <Loader size={15} style={{ animation: "spin 1s linear infinite" }} /> : null}
            {loading ? "Creating account…" : "Create account"}
          </button>
        </form>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } } input:focus { border-color: var(--accent) !important; }`}</style>
    </div>
  );
}
